import React from 'react';

const SunMoonDisk = require('../content/images/SunMoonDisk_w_trans.png');

// Inspired from https://codepen.io/4rron/pen/vYpwyYa

export const toggleTheme = () => {
  const newTheme = localStorage.theme === 'light' ? 'dark' : 'light';
  localStorage.setItem('theme', newTheme);
  if (newTheme==='dark'){
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};


const DarkModeSwitch = ( { theme, setTheme, className } ) => {

  const imgHeight = 60;

  const toggle = () => {
    toggleTheme();
    setTheme(theme === 'light' ? 'dark' : 'light');
  }

  const animateCSS = theme === 'dark' ? 
    'transform rotate-180 hover:rotate-[160deg] transition duration-300 ease-in-out' 
    : 'transform rotate-0 hover:rotate-[20deg] transition duration-300 ease-in-out';
  

  return (
    <div className={`items-center overflow-hidden ${className} cursor-pointer`} onClick={toggle} style={{height: imgHeight/2 + 0.5}}>
      <div className='aspect-square rounded-full bg-light-accent bg-opacity-80'>
        <img src={SunMoonDisk} className={`aspect-square rounded-full border ${animateCSS}`} style={{height: imgHeight}}/>
      </div>
    </div>
  )
}

export default DarkModeSwitch